<template>
  <div>
    <div class="hidden-xs-only">
      <div style="margin-top: 81px">
        <div class="slogan-box" style="justify-content: flex-start;">
          <div class="image-box">
            <img src="../../assets/images/car/car-slogan-1.png" alt="slogan" />
          </div>
          <div class="info-box" style="margin-right: 0; margin-left: 59px">
            <div class="slogan">{{ $t("modelSloganList.slogan1-1") }}<br/>{{ $t("modelSloganList.slogan1-2") }}</div>
            <div class="slogan-desc">
              <span v-for="item in slogan1_desc" :key="item">{{item}}</span>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-bottom: 100px">
        <div class="slogan-box">
          <div class="info-box">
            <div class="slogan">{{ $t("modelSlogan.slogan") }}</div>
            <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc1") }}</div>
            <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc2") }}</div>
            <div class="slogan-desc" style="margin-bottom: 48px">
              {{ $t("modelSlogan.slogan-desc3") }}
            </div>
            <!-- <div class="slogan-btn">{{ $t("modelSlogan.slogan-btn") }}</div> -->
          </div>
          <div class="image-box">
            <img src="../../assets/images/car/car-slogan-2.png" alt="slogan" />
          </div>
        </div>
      </div>
    </div>
    <div class="hidden-sm-and-up">
      <div>
        <div class="title">{{ $t("modelSlogan.title") }}</div>
        <div class="slogan-box">
          <div class="info-box">
            <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc1") }}</div>
            <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc2") }}</div>
            <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc3") }}</div>
            <!-- <div class="slogan-btn">{{ $t("modelSlogan.slogan-btn") }}</div> -->
          </div>
          <div class="image-box">
            <img src="../../assets/images/car/car-slogan-1-mobile.png" alt="slogan" />
          </div>
        </div>
      </div>
      <div>
        <div class="title">{{ $t("modelSlogan.title") }}</div>
        <div class="slogan-box">
          <div class="info-box">
            <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc1") }}</div>
            <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc2") }}</div>
            <div class="slogan-desc">{{ $t("modelSlogan.slogan-desc3") }}</div>
            <!-- <div class="slogan-btn">{{ $t("modelSlogan.slogan-btn") }}</div> -->
          </div>
          <div class="image-box">
            <img src="../../assets/images/car/car-slogan-2-mobile.png" alt="slogan" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      slogan1_desc: this.$t('modelSloganList.slogan1-desc').split('-')
    }
  }
};
</script>
<style lang="scss" scoped>
.hidden-xs-only {
  overflow: hidden;
  .title {
    margin: 118px 0 6px;
    font-size: 50px;
    color: #333;
    font-weight: 700;
  }
  .desc {
    width: 884px;
    margin: 0 auto 125px;
    color: #555;
    line-height: 26px;
  }
  .slogan-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .image-box {
      position: relative;
      flex: 0 0 50%;
      > img {
        display: block;
        width: 100%;
      }
    }
    .info-box {
      flex: 1 1 auto;
      max-width: 480px;
      margin-right: 105px;
      text-align: left;
      .slogan {
        margin-bottom: 25px;
        font-size: 90px;
        line-height: 90px;
        color: #333;
        font-weight: 700;
      }
      .slogan-desc {
        position: relative;
        margin-bottom: 9px;
        color: #555;
        line-height: 26px;
      }
    }
  }
}
.hidden-sm-and-up {
  overflow: hidden;
  padding: 0 25px;
  text-align: left;
  .title {
    margin-top: 60px;
    margin-bottom: 20px;
    font-size: 30px;
    line-height: 32px;
    color: #333;
    font-weight: 700;
  }
  .slogan-box {
    margin-bottom: 60px;
    .info-box {
      margin-bottom: 30px;
      .slogan-desc {
        position: relative;
        padding-left: 20px;
        margin-bottom: 10px;
        font-size: 12px;
        color: #555;
        line-height: 20px;
        &::before {
          position: absolute;
          left: 0;
          top: 7px;
          content: "";
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #555555;
        }
      }
      .slogan-btn {
        width: 140px;
        line-height: 40px;
        color: #fff;
        font-size: 14px;
        text-align: center;
        background-color: #13b0b9;
        cursor: pointer;
      }
    }
    .image-box {
      position: relative;
      > img {
        display: block;
        width: 100%;
      }
      // &::before {
      //   position: absolute;
      //   content: "";
      //   left: 176px;
      //   top: -112px;
      //   width: 214px;
      //   height: 214px;
      //   border-radius: 50%;
      //   border: 1px solid rgba(51, 51, 51, 0.3);
      //   z-index: -1;
      // }
    }
  }
}
</style>